import { render } from "./ActivityList.vue?vue&type=template&id=6cfb8fd2&scoped=true"
import script from "./ActivityList.vue?vue&type=script&lang=js"
export * from "./ActivityList.vue?vue&type=script&lang=js"

import "./ActivityList.vue?vue&type=style&index=0&id=6cfb8fd2&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfb8fd2"]])

export default __exports__